var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIos = function SvgIos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16 21H8a5 5 0 0 1-5-5V8a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.55 9.3a.05.05 0 0 0-.05.05c0 .028.022.05.05.05a.05.05 0 0 0 .05-.05.05.05 0 0 0-.05-.05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.094 14.525h-.488a1.256 1.256 0 0 1-1.256-1.256v-2.588c0-.694.562-1.256 1.256-1.256h.488c.694 0 1.256.562 1.256 1.256v2.588c0 .694-.562 1.256-1.256 1.256",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14.94 13.902a1.2 1.2 0 0 0 1.03.598h1a1 1 0 0 0 1-1v-.279a1 1 0 0 0-.683-.949l-1.632-.544a1 1 0 0 1-.684-.949V10.5a1 1 0 0 1 1-1h1c.444 0 .812.243 1.027.595M6.55 11.9v2.5"
  })));
};
export { SvgIos as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNDgyYzg2OWYzNDBmZmMxNGFlYTc1ODE2MzYxMWQ2YmEuc3ZnIjs=";